/**
 * Conversa de atendimento de chamado — spec 2026-09-26 §4.3 e §4.7.
 *
 * O texto do primeiro turno é FIXO e fica visível na conversa como mensagem de
 * quem clicou (como no "Explicar este alerta"). O contexto do chamado quem monta
 * é o servidor, a cada turno — nada do chamado viaja no corpo.
 */
import type { ConversationEnvelope } from '@/api/chat'

export interface PedidoDeInicioDeAtendimento {
  chamadoId: number
  protocolo: string
}

export interface EstadoDeInicioDeAtendimento {
  iniciarAtendimentoChamado?: PedidoDeInicioDeAtendimento
  /** Spec 2026-10-16 §4.4: o item "Finalizar chamado com IA" pede o fechamento ao @Atendente. */
  finalizarChamado?: PedidoDeInicioDeAtendimento
}

export function textoDoInicioDeAtendimento(protocolo: string): string {
  return `Inicie o atendimento do chamado ${protocolo}: resuma a ação que ele pede, o alvo e o que você pode executar, e ofereça as ações com confirmação.`
}

export function textoDoFinalizarChamado(protocolo: string): string {
  return `Redija o fechamento do chamado ${protocolo} para o solicitante: o que foi feito, quando, ` +
    `o impacto (se ficou fora do ar, por quanto tempo) e como voltar atrás se algo der errado. ` +
    `Use só o que está nesta conversa e no chamado; não invente horário nem número. ` +
    `Proponha a ação chamado_finalizar com esse texto.`
}

/** Toda mensagem digitada vai ao @Atendente: DM com ele, ou conversa de chamado. */
export function mandaAoAtendente(envelope?: Pick<ConversationEnvelope, 'is_atendente_dm' | 'is_chamado'> | null): boolean {
  return !!(envelope?.is_atendente_dm || envelope?.is_chamado)
}
